'use client';

import Link from 'next/link';

import { center } from '@flipster/styled-system/patterns';
import DocumentHistoryIcon from '@flipster/ui/assets/svgs/document-history.svg';

const HistoryLink = () => {
  return (
    <Link className={center({ color: 'content.default.level-4' })} href='/history/earn' target='_blank'>
      <DocumentHistoryIcon />
    </Link>
  );
};

export default HistoryLink;
